export enum Business {
  SC = 'SC',
  GT = 'GT',
  PC = 'PC',
}